import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { bouncy } from 'ldrs'

bouncy.register()


import "react-toastify/dist/ReactToastify.css";

import Public from "./pages/Public";
import NotFound from "./pages/NotFound";
import Maintenance from "./pages/Maintenance";
import Confidentialite from "./pages/Confidentialite";
import MentionsLegales from "./pages/MentionsLegales";


const LoadingFallback = () => (
  <div className="flex flex-col  justify-center items-center h-screen">
    <div className="text-lg font-semibold text-gray-700 mb-4 animate-pulse">
      Chargement...
    </div>
    <l-bouncy
      size="40"
      bg-opacity="0.1"
      speed="1.75"
      color="#D4AF37"
    ></l-bouncy>
  </div>
);

export default function App() {
  useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG' || e.target.style.backgroundImage) {
        e.preventDefault();
      }
    };
    
    // Désactiver les raccourcis clavier d'inspection (F12, Ctrl+Shift+I/J/C, Ctrl+U)
    const handleKeyDown = (e) => {
      if (e.key === 'F12') e.preventDefault();
      if (e.ctrlKey && e.shiftKey && ['I', 'i', 'J', 'j', 'C', 'c'].includes(e.key)) e.preventDefault();
      if (e.ctrlKey && ['U', 'u'].includes(e.key)) e.preventDefault();
      // Pour les utilisateurs Mac (Cmd+Option+I/J/U)
      if (e.metaKey && e.altKey && ['I', 'i', 'J', 'j', 'C', 'c'].includes(e.key)) e.preventDefault();
      if (e.metaKey && ['U', 'u'].includes(e.key)) e.preventDefault();
    };

    // Désactiver le clic droit globalement sur les images
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path="/"
          element={<Public />}
        />
        <Route
          path="/maintenance"
          element={<Maintenance />}
        />
        <Route
          path="/confidentialite"
          element={<Confidentialite />}
        />
        <Route
          path="/mentions-legales"
          element={<MentionsLegales />}
        />
        
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </Suspense>
  );
}
